import React, { useState } from 'react';
import AccordionItem from '@/atomic/atoms/AccordionItem';

interface AccordionListItem {
  title: string;
  text?: string;
  element?: string;
}

interface AccordionListProps {
  items: AccordionListItem[];
  iconOpen?: string;
  iconClosed?: string;
  iconSize?: number;
  iconPosition?: 'left' | 'right';
  titleClassName?: string;
  defaultOpenIndex?: number | null;
  itemClassName?: string;
  buttonClassName?: string;
  contentClassName?: string;
  textClassName?: string;
  dividerClassName?: string;
  hideDivider?: boolean;
}

const AccordionList: React.FC<AccordionListProps> = ({
  items,
  iconOpen,
  iconClosed,
  iconSize,
  iconPosition,
  titleClassName,
  defaultOpenIndex = null,
  itemClassName,
  buttonClassName,
  contentClassName,
  textClassName,
  dividerClassName,
  hideDivider,
}) => {
  const [openedIndex, setOpenedIndex] = useState<number | null>(defaultOpenIndex);

  return (
    <>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          isOpen={openedIndex === index}
          onToggle={() => setOpenedIndex(openedIndex === index ? null : index)}
          element={item.element}
          iconOpen={iconOpen}
          iconClosed={iconClosed}
          iconSize={iconSize}
          iconPosition={iconPosition}
          titleClassName={titleClassName}
          className={itemClassName}
          buttonClassName={buttonClassName}
          contentClassName={contentClassName}
          textClassName={textClassName}
          dividerClassName={dividerClassName}
          hideDivider={hideDivider}
        >
          {item.text && (
            <p className={textClassName || "text-base text-gray-500"}>
              {item.text.split("\n").map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          )}
        </AccordionItem>
      ))}
    </>
  );
};

export default AccordionList; 